// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getLocalizedCurrency } from "@store/Overrides/Components/LocalizedCurrency";
import { useCallback } from "react";

const useLocalizeCurrency = (): ((amount: string | number) => string) => {
    const language = useAppSelector(state => state.context.session.language);
    const currencySymbol = useAppSelector(state => state.context.session.currency?.currencySymbol) || "$";
    const localizeCurrency = (amount: string | number) => {
        if (!amount && amount !== 0) {
            return "";
        }
        const amountNumber = typeof amount === "string" ? parseFloat(amount) : amount;
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(amountNumber)) {
            return String(amount);
        }
        if (!language || !currencySymbol) {
            return String(amount);
        }
        return getLocalizedCurrency({ amount: amountNumber, language, currencySymbol });
    };
    return useCallback(localizeCurrency, [language, currencySymbol]);
};

export default useLocalizeCurrency;
